import './_product-lifestyle-banner.scss';

export default () => {};
